import { Fragment } from 'react';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';

import styles from './styles.module.scss';
import { parseErknmValue } from '../common/parseErknmValue';
import { KnmErpObjectChecklist } from './KnmErpObjectChecklist';
import { KnmErpObjectResult } from './KnmErpObjectResult';

interface IKnmErpObjectErvkProps {
  passportData?: IKnmPreview;
}

export const KnmErpObjectErvk = ({ passportData }: IKnmErpObjectErvkProps) => {
  const objectsErvk = passportData?.objectsErvk;
  return (
    <div className={styles.ColumnContent}>
      {objectsErvk &&
        objectsErvk.length > 0 &&
        objectsErvk.map((obj, index) => (
          <Fragment key={index}>
            <span className={styles.SectionTitle}>{`Объект проведения КНМ №${index + 1}`}</span>
            <div className={styles.SectionTitle}>Место #{index + 1}</div>
            {obj.notInFIAS !== undefined && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Иное указание места (нет в ФИАС)</div>
                <div className={styles.ColValue}>
                  <Checkbox checked={obj.notInFIAS} size="medium" type="checkbox" theme="system" disabled={true} />
                </div>
              </div>
            )}
            <div className={styles.Row}>
              <div className={styles.ColText}>Место объекта проведения КНМ</div>
              <div className={styles.ColValue}>{obj.address ?? obj.manualAddress}</div>
            </div>
            {obj.fiasRegion && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Субъект РФ</div>
                <div className={styles.ColValue}>
                  {typeof obj.fiasRegion === 'object' ? obj.fiasRegion.name : obj.fiasRegion}
                </div>
              </div>
            )}
            {obj.region && !obj.fiasRegion && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Субъект РФ</div>
                <div className={styles.ColValue}>{obj.region}</div>
              </div>
            )}
            {obj.objectType && obj.objectType.value && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Тип объекта проведения КНМ</div>
                <div className={styles.ColValue}>
                  {parseErknmValue<{ title?: string }>(obj.objectType.value)?.title}
                </div>
              </div>
            )}
            {obj.riskCategory && obj.riskCategory.value && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Категория риска</div>
                <div className={styles.ColValue}>
                  {parseErknmValue<{ title?: string }>(obj.riskCategory.value)?.title}
                </div>
              </div>
            )}

            {obj.isAddressHazard && (
              <div className={styles.Row}>
                <div className={styles.ColText}>Является ОПО</div>
                <div className={styles.ColValue}>
                  <Checkbox
                    checked={obj.isAddressHazard}
                    size="medium"
                    type="checkbox"
                    theme="system"
                    disabled={true}
                  />
                </div>
              </div>
            )}
            <KnmErpObjectChecklist chlistHeaders={obj.chlistHeaders} />
            {obj.supervisions &&
              obj.supervisions.map(supervision => (
                <>
                  <span className={styles.SectionTitle}>Виды государственного контроля (надзора)</span>
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Вид государственного контроля (надзора)</div>
                    <div className={styles.ColValue}>{supervision.name}</div>
                  </div>
                </>
              ))}
            <KnmErpObjectResult objectResult={obj.result} />
          </Fragment>
        ))}
    </div>
  );
};
